import tail from 'tail.select/js/tail.select-full.min';

export default class CustomSelect {
	static init() {
		Array.prototype.forEach.call(document.querySelectorAll('.select-location'), el => {
			new CustomSelect(el);
		});
	}

	constructor(el) {
		let updateLabel = (el) => {
			let label = el
			if (!label) return;
			let country = label.innerHTML.match(/\[(.*?)\]/);
			country = country ? country[1] : false;

			if (country) {
				let city = label.innerHTML.replace(/ *\[[^\]]*]/g, '');
				label.innerHTML = city + ', ' + country;
			}
		}

		const selectOptions = {
			search: true,
			searchConfig: [
				"group", "text", "value"
			],
			descriptions: true,
			count: false,
			hideSelected: false,
			multiple: false,
			stayOpen: false,
			deselect: false,
			placeholder: '',
			cbLoopItem: (item) => {
				let newItem = document.createElement('li');
				newItem.innerHTML = item.value.replace(/ *\[[^\]]*]/g, '');
				if (item.selected) newItem.classList.add('selected');

				return newItem;
			},
			cbComplete: function (item) {
				updateLabel(item.querySelector('.select-label .label-inner'));

				item.querySelector('.search-input').addEventListener('input', () => {
					updateLabel(item.querySelector('.select-label .label-inner'));
				});
			}
		}

		return tail(el, selectOptions)
			.on('change', function (item, state) {
				if (state === 'unselect') return;

				updateLabel(item.option.closest('.form-group__icon-wrapper').querySelector('.select-label .label-inner'));
			})
			.on('close', function () {
				updateLabel(el.parentElement.querySelector('.select-label .label-inner'));
			})
			.on('open', function () {
				updateLabel(el.parentElement.querySelector('.select-label .label-inner'));
			})
	}
}
